import React from 'react'

import { Home as HomeComponent } from '../../../Components/Player/Home'
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

export const Home = () => {
  const navigate = useNavigate();
  const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });
  return (
    <>
      {
        isDesktopOrLaptop ? navigate("/404") : <HomeComponent />
      }
    </>
  )
}
